// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var ActiveStatus;
(function (ActiveStatus) {
    ActiveStatus["UNKNOWN"] = "UNKNOWN";
    ActiveStatus["ACTIVE"] = "ACTIVE";
    ActiveStatus["INACTIVE"] = "INACTIVE";
    ActiveStatus["DECEASED"] = "DECEASED";
})(ActiveStatus || (ActiveStatus = {}));
export var ActiveStatus_index;
(function (ActiveStatus_index) {
    ActiveStatus_index[ActiveStatus_index["UNKNOWN"] = 0] = "UNKNOWN";
    ActiveStatus_index[ActiveStatus_index["ACTIVE"] = 1] = "ACTIVE";
    ActiveStatus_index[ActiveStatus_index["INACTIVE"] = 2] = "INACTIVE";
    ActiveStatus_index[ActiveStatus_index["DECEASED"] = 3] = "DECEASED";
})(ActiveStatus_index || (ActiveStatus_index = {}));
export var ValidatedImageType;
(function (ValidatedImageType) {
    ValidatedImageType["UNKNOWN_IMAGETYPE"] = "UNKNOWN_IMAGETYPE";
    ValidatedImageType["DOG"] = "DOG";
    ValidatedImageType["CAT"] = "CAT";
    ValidatedImageType["HORSE"] = "HORSE";
    ValidatedImageType["BIRD"] = "BIRD";
    ValidatedImageType["CHAMELEON"] = "CHAMELEON";
    ValidatedImageType["MOUSE"] = "MOUSE";
    ValidatedImageType["REPTILE"] = "REPTILE";
    ValidatedImageType["SMALLMAMMAL"] = "SMALLMAMMAL";
    ValidatedImageType["LARGEMAMMAL"] = "LARGEMAMMAL";
})(ValidatedImageType || (ValidatedImageType = {}));
export var ValidatedImageType_index;
(function (ValidatedImageType_index) {
    ValidatedImageType_index[ValidatedImageType_index["UNKNOWN_IMAGETYPE"] = 0] = "UNKNOWN_IMAGETYPE";
    ValidatedImageType_index[ValidatedImageType_index["DOG"] = 1] = "DOG";
    ValidatedImageType_index[ValidatedImageType_index["CAT"] = 2] = "CAT";
    ValidatedImageType_index[ValidatedImageType_index["HORSE"] = 3] = "HORSE";
    ValidatedImageType_index[ValidatedImageType_index["BIRD"] = 4] = "BIRD";
    ValidatedImageType_index[ValidatedImageType_index["CHAMELEON"] = 5] = "CHAMELEON";
    ValidatedImageType_index[ValidatedImageType_index["MOUSE"] = 6] = "MOUSE";
    ValidatedImageType_index[ValidatedImageType_index["REPTILE"] = 7] = "REPTILE";
    ValidatedImageType_index[ValidatedImageType_index["SMALLMAMMAL"] = 8] = "SMALLMAMMAL";
    ValidatedImageType_index[ValidatedImageType_index["LARGEMAMMAL"] = 9] = "LARGEMAMMAL";
})(ValidatedImageType_index || (ValidatedImageType_index = {}));
export const PetsAPI = {
    GetPetDetailsByServiceableId(fn, req) {
        return fn(`/pets-api/v1/pet-details-by-sid?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPetsByPersonId(fn, req) {
        return fn(`/pets-api/v1/pets-by-person?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SearchPersons(fn, req) {
        return fn(`/pets-api/v1/search-persons?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SearchPets(fn, req) {
        return fn(`/pets-api/v1/search-pets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SearchPersonByPhoneNumberWithPets(fn, req) {
        return fn(`/pets-api/v1/search-person-pets-by-phone?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPersonsWithPets(fn, req) {
        return fn(`/pets-api/v1/list-persons-with-pets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Returns limited pet details with their person/owner for contacts listing page
     */
    ListPetsWithPersons(fn, req) {
        return fn(`/pets-api/v1/list-pets-with-person?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * run export using data-infra export
     */
    RunExport(fn, req) {
        return fn(`/pets-api/v1/run-export`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * get pet information by pet_serviceable_id/pet_id
     */
    FetchPet(fn, req) {
        return fn(`/pets-api/v1/pet?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * fetch pets by personid
     */
    FetchPetsByPersonId(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/pets-api/v1/person/${req["personId"]}/pets?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "GET" });
    },
    /**
     * bulk fetch pet details by serviceable_ids
     */
    BulkFetchPetsByServiceableIds(fn, req) {
        return fn(`/pets-api/v1/bulk-fetch-pets`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
